// extracted by mini-css-extract-plugin
export default {"link":"UploadFile_link__PwQrx","remove":"UploadFile_remove__ZsTeA"};